import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/react'
import * as Icons from './Icons/icons'

const IconInline = (props) => {
  const { glyph, size = 14, fill = 'currentColor', trailing, title } = props
  const TheIcon = Icons[glyph]

  return (
    <TheIcon
      css={css`
        margin-right: ${trailing ? 0 : '0.4em'};
        margin-left: ${trailing ? '0.4em' : 0};
        fill: ${fill};
        width: ${size}px;
        height: ${size}px;
        display: inline-block;
        vertical-align: middle;
      `}
      title={title}
    />
  )
}

IconInline.propTypes = {
  glyph: PropTypes.string.isRequired,
  size: PropTypes.number,
  fill: PropTypes.string,
  trailing: PropTypes.bool,
  title: PropTypes.string,
}

export default IconInline
